import { useCustomerOrders } from "@Components/account/hooks/useCustomerOrders";
import { ACCOUNT_MENU } from "@Constants/common";
import { nextAppEnv } from "@Utils/environment";
import { isCanadianLocale } from "@Utils/locale";
import { useCustomer } from "@wff/hooks/useCustomer";
import { useLocaleRouter } from "@wff/hooks/useLocaleRouter";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import { NavLink } from "./NavLink";
import classes from "./Header.module.scss";

// TO DO: generalize the filtering of the Nav items for Membership and Favorites.
const MENTION_ME_REFERRAL_PROGRAM_ENABLED_MY_ACCOUNT =
  nextAppEnv.feature_toggle.CA.mentionMeReferralProgramMyAccount;

const favoritesFeatureEnabled =
  nextAppEnv.feature_toggle.CA.favorites === "true";

const membershipFeatureEnabled =
  nextAppEnv.feature_toggle.CA.membership === "true";

interface AccountNavLinksProps {
  showOptions: boolean;
  onNavLinkClick: () => void;
}

export const AccountNavLinks = ({
  showOptions,
  onNavLinkClick,
}: AccountNavLinksProps) => {
  const { push } = useLocaleRouter();
  const currentLocale = useAppSelector(localeSelector);
  const { logoutCustomer, isMember } = useCustomer();
  const MEMBERSHIP_NAV_ITEM_TEXT = isMember
    ? ACCOUNT_MENU.NAV_ITEM.MEMBERSHIP
    : "Membership";

  const { hasOrdersInPastTwoYears } = useCustomerOrders();

  const handleAccountNavClick = (fn?: () => void) => {
    if (typeof fn === "function") {
      fn();
    }

    onNavLinkClick();
  };

  let items = [
    {
      text: ACCOUNT_MENU.NAV_ITEM.MY_ORDERS,
      onClick: () => handleAccountNavClick(() => push("/account?tab=orders")),
    },
    {
      text: ACCOUNT_MENU.NAV_ITEM.FAVORITES,
      onClick: () =>
        handleAccountNavClick(() => push("/account?tab=favorites")),
    },
    {
      text: ACCOUNT_MENU.NAV_ITEM.COMMUNICATION_PREFERENCES,
      onClick: () =>
        handleAccountNavClick(() => push("/account?tab=communication")),
    },
    {
      text: ACCOUNT_MENU.NAV_ITEM.PREVIOUSLY_ORDERED,
      onClick: () =>
        handleAccountNavClick(() => push("/account?tab=previously-ordered")),
    },
    {
      text: MEMBERSHIP_NAV_ITEM_TEXT,
      onClick: () =>
        handleAccountNavClick(() => push("/account?tab=membership")),
    },
    {
      text: ACCOUNT_MENU.NAV_ITEM.MENTION_ME,
      onClick: () => handleAccountNavClick(() => push("/account?tab=referral")),
    },
    {
      text: ACCOUNT_MENU.NAV_ITEM.LOGOUT,
      onClick: () => handleAccountNavClick(logoutCustomer),
    },
  ];

  if (isCanadianLocale(currentLocale) && !membershipFeatureEnabled) {
    const updatedItems = items.filter(
      (item) => !item?.text?.includes("Membership")
    );
    items = updatedItems;
  }

  if (isCanadianLocale(currentLocale) && !favoritesFeatureEnabled) {
    const updatedItems = items.filter(
      (item) => !item?.text?.includes("Favourites")
    );
    items = updatedItems;
  }

  if (
    !MENTION_ME_REFERRAL_PROGRAM_ENABLED_MY_ACCOUNT ||
    (MENTION_ME_REFERRAL_PROGRAM_ENABLED_MY_ACCOUNT && !hasOrdersInPastTwoYears)
  ) {
    const updatedItems = items.filter(
      (item) => !item?.text?.includes(ACCOUNT_MENU.NAV_ITEM.MENTION_ME)
    );
    items = updatedItems;
  }

  return (
    <div
      className={
        showOptions
          ? classes["customer-info-options-active"]
          : classes["customer-info-options"]
      }
    >
      {items.map((item) => (
        <NavLink key={item.text} onClick={item.onClick}>
          {item.text}
        </NavLink>
      ))}
    </div>
  );
};
